/**
 * ui-renderers/core.ts
 * Shared utility functions used across multiple renderer modules.
 */

import { dom } from '../dom';

export function escapeHtml(str: unknown): string {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function escapeAttr(str: string): string {
  return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

export function formatRelativeTime(unixTs: number | null | undefined): string {
  if (!unixTs) return '';
  const diff = Date.now() / 1000 - unixTs;
  if (diff < 60)     return 'just now';
  if (diff < 3600)   return Math.floor(diff / 60) + 'm ago';
  if (diff < 86400)  return Math.floor(diff / 3600) + 'h ago';
  if (diff < 604800) return Math.floor(diff / 86400) + 'd ago';
  return new Date(unixTs * 1000).toLocaleDateString();
}

export function showToast(msg: string, type?: string) {
  const existing = document.querySelector('.ai-toast');
  if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
  const toast = document.createElement('div');
  toast.className = 'ai-toast' + (type === 'error' ? ' ai-toast-error' : '');
  toast.textContent = msg;
  document.body.appendChild(toast);
  setTimeout(() => toast.classList.add('ai-toast-out'), 2400);
  setTimeout(() => { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 2700);
}

export function setToolCallStatus(label: string | null) {
  const bar    = dom.toolStatus;
  const textEl = document.getElementById('ai-tool-status-text');

  if (!bar) return;

  if (!label) {
    bar.style.display = 'none';
    if (textEl) textEl.textContent = '';
    return;
  }

  if (textEl) textEl.textContent = label;
  bar.style.display = 'flex';
}

export function enhanceCodeBlocks(msgEl: HTMLElement) {
  if (!msgEl) return;
  msgEl.querySelectorAll('code').forEach(block => {
    if (block.dataset.enhanced) return;
    block.dataset.enhanced = '1';
    block.classList.add('inline-code');
    const copyBtn = document.createElement('button');
    copyBtn.className = 'copy-code-btn';
    copyBtn.textContent = '\uD83D\uDCCB';
    copyBtn.title = 'Copy code';
    copyBtn.type  = 'button';
    copyBtn.addEventListener('click', e => {
      e.stopPropagation();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(block.textContent || '').then(() => {
          showToast('Code copied!');
          if (window.navigator && window.navigator.vibrate) window.navigator.vibrate(20);
        });
      }
    });
    if (block.parentNode) block.parentNode.insertBefore(copyBtn, block.nextSibling);
  });
}
